import { useEffect } from 'react'
import { connect } from 'react-redux'
import { useNavigate, useNavigationType } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import UnauthorizedLayoutWrapper from 'wrappers/UnauthorizedLayoutWrapper'
import { SplashScreen } from '../components/shared/loading-screen'
import { EmailMissing } from '../components/popups/signUp'
import { POP } from '../constants/app'
import { FACEBOOK_APP_SETTINGS_URL } from '../constants/externalUrls'
import { HOME_URL } from '../constants/navigation'
import { closeEmailMissing, getCurrentUser } from '../store/actions/auth'
import {
  isAuthenticated,
  isCheckingAuth,
  isNotAuthenticated
} from '../util/account.helpers'
import { openExternalUrl } from '../util/app/app.helpers'

const requireUnauth = (ChildComponent) => {
  const ComposedComponent = (props) => {
    const navigate = useNavigate()
    const navigationType = useNavigationType()
    const { authState, getCurrentUser, closeEmailMissing } = props

    useEffect(() => {
      if (isNotAuthenticated(authState) && navigationType === POP) {
        getCurrentUser()
      } else if (isAuthenticated(authState)) {
        navigate(HOME_URL, { replace: true })
      }
    }, [])

    useEffect(() => {
      if (isAuthenticated(authState)) {
        navigate(HOME_URL, { replace: true })
      }
    }, [authState])

    const handleShareEmail = () => {
      handleCloseEmailMissing()
      openExternalUrl(FACEBOOK_APP_SETTINGS_URL)
    }

    const handleCloseEmailMissing = () => {
      closeEmailMissing()
    }

    const renderPopup = () => {
      const { emailMissing } = props
      if (emailMissing) {
        return (
          <EmailMissing
            onSubmit={handleShareEmail}
            onCancel={handleCloseEmailMissing}
          />
        )
      }
    }

    return isCheckingAuth(props.authState) ? (
      <SplashScreen />
    ) : (
      <UnauthorizedLayoutWrapper>
        <ChildComponent {...props} />
        {renderPopup()}
      </UnauthorizedLayoutWrapper>
    )
  }

  const mapStateToProps = ({ authReducer }) => {
    const { authProfile } = authReducer
    const { authState, emailMissing } = authProfile
    return {
      authState,
      emailMissing
    }
  }

  const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
      {
        getCurrentUser,
        closeEmailMissing
      },
      dispatch
    )

  return connect(mapStateToProps, mapDispatchToProps)(ComposedComponent)
}

export default requireUnauth
